var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_show_mask),expression:"is_show_mask"}],staticClass:"mask",style:('width:'+_vm.mask_width()+'px;left:'+_vm.mask_left()+'px;height:'+_vm.mask_height()+'px;top:'+_vm.mask_top()+'px'),attrs:{"id":_vm.eId}})
}
var staticRenderFns = []

export { render, staticRenderFns }